import { type FC, useContext, useMemo } from 'react'
import classNames from 'classnames'
import { BadgesView } from './BadgeView'
import styles from './EmailEditor.module.scss'
import { type Badge } from './emailTemplateTypes'
import { lockedHtmlForEditor } from './lockedHtml'
import { VariableLabelsContext } from './VariableLabelsContext'

export interface LockedBlockViewProps {
  html: string
  label: string
  badges: Badge[]
  showLockTag?: boolean
}

export const LockedBlockView: FC<LockedBlockViewProps> = ({ html, label, badges, showLockTag = true }) => {
  const labels = useContext(VariableLabelsContext)
  const markup = useMemo(() => ({ __html: lockedHtmlForEditor(html, labels) }), [html, labels])
  return (
    <div className={styles.lockedBox}>
      {badges.length ? <BadgesView badges={badges} /> : null}
      <div className={styles.lockedBody} dangerouslySetInnerHTML={markup} />
      {showLockTag ? (
        <span
          className={classNames(
            styles.lockTag,
            'position-absolute d-flex align-items-center justify-content-center rounded-circle border zocks-border-color-gray-300 zocks-bg-color-white zocks-text-gray-600',
          )}
          title={label}
        >
          <i className='bi bi-lock' aria-hidden='true' />
        </span>
      ) : null}
    </div>
  )
}
